import { DebouncedField } from '@ui/components/DebouncedField';
import { PercentIcon } from '@ui/components/Icons';
import { actions } from '@ui/features/quote-builder/state/reducer';
import { selectQuotePriceField } from '@ui/features/quote-builder/state/selectors/quote-price-field';
import { useDispatch } from '@ui/hooks/useDispatch';
import { useSelector } from '@ui/hooks/useSelector';

import { useQuotePriceContext } from './QuotePriceProvider';

/**
 * Displayed as "Target Gross Margin" in the UI.
 */
export function BaseGrossMargin() {
  const dispatch = useDispatch();
  const { quoteLineUuid, quotePriceUuid, isFirstQuotePrice } =
    useQuotePriceContext();

  const { elementId, value, issues } = useSelector((state) =>
    selectQuotePriceField(
      state,
      quoteLineUuid,
      quotePriceUuid,
      'baseGrossMargin',
    ),
  );

  function handleChange(margin: string) {
    dispatch(
      actions.baseGrossMarginChanged({
        quoteLineUuid,
        quotePriceUuid,
        value: margin,
      }),
    );
  }

  return (
    <DebouncedField
      id={elementId}
      label="Target Gross Margin"
      showLabel={isFirstQuotePrice}
      leftIcon={PercentIcon}
      value={value}
      onChange={handleChange}
      inputMode="decimal"
      isInvalid={issues.length > 0}
      error={issues[0]?.description}
    />
  );
}
